import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import AccountField from 'components/field/AccountField';
import TextField from 'components/field/TextField';
import AccountYieldsListFilters from 'pages/account-yields/list/AccountYieldsListFilters';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteAccountYield } from 'store/actions/account-yields/deleteAccountYields';
import { fetchAccountYields } from 'store/actions/account-yields/fetchAccountYields';

const AccountYieldsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <AccountYieldsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchAccountYields }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    triggerInformationModal={ false }
                >
                    <AccountField
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        display='name'
                        label='resources.account_yields.fields.accountId'
                        source='account_id'
                    />

                    <TextField
                        column={ {
                            link: false,
                            sortable: false,
                            width: '10%',
                        } }
                        appendText='%'
                        label='resources.account_yields.fields.yield'
                        source='yield'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteAccountYield } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

AccountYieldsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(AccountYieldsList);



// WEBPACK FOOTER //
// ./src/pages/account-yields/list/AccountYieldsList.js